import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import Schedule from './components/Schedule';
import Map from './components/Map';

const ContactPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Contact Us | Schedule Appointment | Guidepost Pediatrics Wasilla
        </title>
        <meta
          name="description"
          content="Contact Guidepost Pediatric Therapies in Wasilla, Alaska. Schedule your child's evaluation for physical, occupational, or speech therapy. Call us today!"
        />
        <meta
          name="keywords"
          content="pediatric therapy contact Wasilla, schedule appointment Alaska, therapy evaluation Wasilla, Guidepost Pediatrics contact"
        />
      </Helmet>
      <HeroSection />
      <Schedule />
      <Map />
    </div>
  );
};

export default ContactPage;
